const template = require('./splash-screen.html');

export default {
    template
};
